import { axiosWithConfig } from '@assembly/config/axios'

export const loginClientDashboard = (payload: any) => {
  return axiosWithConfig.post(`/auth/debug-login/client-dashboard`, payload, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export const loginPartnerDashboard = (payload: any) => {
  return axiosWithConfig.post(`/auth/debug-login/partner-dashboard`, payload, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export const syncJHRJobs = () => {
  return axiosWithConfig.post(`/recruiting/jhr/sync`)
}

export interface CandidateQuestionFilter {
  question: string;
  matchType: string;
  match: string;
}

export interface ValidateCandidateQuestionFilter {
  filter: CandidateQuestionFilter;
  answer: string;
}

export const testQuestionnaireFilter = (payload: ValidateCandidateQuestionFilter) => {
  return axiosWithConfig.post(`/recruiting/questionnaire/filter/test`, payload)
}
